function Utils() {

}

Utils.prototype = {
    constructor: Utils,
    isElementInView: function (element, fullyInView) {
        var pageTop = $(window).scrollTop();
        var pageBottom = pageTop + $(window).height();
        var elementTop = $(element).offset().top;
        var elementBottom = elementTop + $(element).height();

        if (fullyInView === true) {
            return ((pageTop < elementTop) && (pageBottom > elementBottom));
        } else {
            return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
        }
    }
};

var Utils = new Utils();

$('.header-content').css('opacity', '0');

$(window).scroll(function () {
  let announcement_in_view = Utils.isElementInView($('#shopify-section-announcement-bar'), false);

  if (!announcement_in_view) {
    $('#shopify-section-header').css('position', 'fixed');
    $('#header .header__sticky-logo-wrapper').css('display', 'none');
    
  } else {
    $('#header .header__sticky-logo-wrapper').css('display', 'flex');
    $('#shopify-section-header').css('position', 'unset');
  }
});